import React from "react";
import { FiCopy, FiLink } from "react-icons/fi";
import { CopyToClipboard } from "react-copy-to-clipboard";
import SimpleTooltip from "./SimpleTooltip";

class ClickToCopyWrapper extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isCopied: false,
    };
  }

  render() {
    const { isCopied } = this.state;
    const {
      copyText,
      tooltipMessage = "Click to copy",
      buttonText = "",
      iconType = "COPY",
      isTextBlue = false,
      place = "top",
      keepRefresh,
    } = this.props;
    const copyTextStr =
      typeof copyText !== "string" ? copyText.toString() : copyText;

    return (
      <>
        <SimpleTooltip
          key={copyTextStr} // Ensure CopyToClipboard (child) updates when copyTextStr changes
          tooltipText={isCopied ? "Copied!" : tooltipMessage}
          place={place}
          keepRefresh={keepRefresh}
        >
          <CopyToClipboard
            text={copyTextStr}
            onCopy={() => {
              this.setState({ isCopied: true });
            }}
          >
            <div
              className={`flex cursor-pointer items-center gap-1 px-2 ${isTextBlue && "text-blue-700"
                } hover:text-blue-600`}
              onMouseLeave={() => this.setState({ isCopied: false })}
              onClick={(e) => e.stopPropagation()}
            >
              {buttonText}
              {iconType === "COPY" && <FiCopy></FiCopy>}
              {iconType === "LINK" && <FiLink></FiLink>}
            </div>
          </CopyToClipboard>
        </SimpleTooltip>
      </>
    );
  }
}

export default ClickToCopyWrapper;
